import { z } from 'zod';
import { nonEmptyStringSchema } from '@shared/schemas';

export const ZoneId = nonEmptyStringSchema.brand<'ZoneId'>();
export type ZoneId = z.infer<typeof ZoneId>;
